<template>
    <div class="footer">
        <div class="w1200 box">
            <div class="one">
                <span style="font-size: 26px;margin: 0 100px 0px 10px">联系我们</span>
                <span>0759-6620678</span>
                <span style="display: inline-block; height: 26px; width:1px;margin: 0 10px; background-color: #7E808A;color: #7E808A;">&nbsp;</span>
                <span>更多联系信息</span>
                <span style="font-size: 12px;position: absolute;right: 50px">（网站文字与图片部分来源于网络，如有侵权请联系我们）</span>
            </div>
            <div class="two">
                <div class="item" v-for="i in navlist">
                    <div class="item_title hover" @click="goTo(i.href)">{{i.name}}</div>
                    <ul >
                        <li class="hover" v-for="j in i.child" @click="goTo(j.href)"> {{j.name}}</li>

                    </ul>
                </div>
                <div class="item" style="margin-left: 50px;padding-top: 50px">

                    <el-popover
                            placement="top-start"
                            width="270"
                            trigger="hover"
                    >
                        <img style="width: 270px" src="../../assets/img/gov/gov1.png">
                        <div class="refer" slot="reference">
                            <img  src="../../assets/img/gov/qr2.png">
                            <span>广东省人民政府门户网站</span>
                        </div>
                    </el-popover>
                    <el-popover
                            placement="top-start"
                            width="270"
                            trigger="hover"
                    >
                        <img style="width: 270px" src="../../assets/img/gov/gov2.png">
                        <div class="refer" slot="reference">
                            <img  src="../../assets/img/gov/qr2.png">
                            <span>广东政务服务APP</span>
                        </div>
                    </el-popover>
                    <el-popover
                            placement="top-start"
                            width="270"
                            trigger="hover"
                    >
                        <img style="width: 270px" src="../../assets/img/gov/qr.jpg">
                        <div class="refer" slot="reference">
                            <img  src="../../assets/img/gov/qr2.png">
                            <span>廉江旅游小程序</span>
                        </div>
                    </el-popover>
                    <el-popover
                            placement="top-start"
                            width="270"
                            trigger="hover"
                    >
                        <img style="width: 270px" src="../../assets/img/gov/gov4.jpg">
                        <div class="refer" slot="reference">
                            <img  src="../../assets/img/gov/qr2.png">
                            <span>廉江旅游公众号</span>
                        </div>
                    </el-popover>
                </div>

            </div>


        </div>
        <div class="three">
            Copyright © 广东国地规划科技股份有限公司 版权所有　粤ICP备19020983号-2　<br/>
            <a  href="http://beian.miit.gov.cn" target="_blank">工业和信息化部备案管理系统</a>
        </div>

    </div>
</template>
<script>
    export default {
        name: "footer1",
        data() {
            return {
                navlist:[
                    {name:'了解廉江',href:'index.html#/list1?ljcode=ljgl&columnId=40288a9d6e91c70a016e91cabebd0006&rootColumnId=40288a9d6e91c70a016e91c787ba0000',
                        child:[
                            {name:'廉江概览',href:'index.html#/list1?ljcode=ljgl&columnId=40288a9d6e91c70a016e91cabebd0006&rootColumnId=40288a9d6e91c70a016e91c787ba0000'},
                            {name:'廉江动态',href:'index.html#/list2?ljcode=ljdt&columnId=40288a9d6e91c70a016e91caf27c0007&rootColumnId=40288a9d6e91c70a016e91c787ba0000'},
                            {name:'节庆活动',href:'index.html#/jqhd?ljcode=jqhd&columnId=40288a9d6e91c70a016e91cb31640008&rootColumnId=40288a9d6e91c70a016e91c787ba0000'},
                            {name:'音画廉江',href:'index.html#/yhlj?ljcode=yhlj&columnId=40288a9d6e91c70a016e91cb9d910009&rootColumnId=40288a9d6e91c70a016e91c787ba0000'}]},
                    {name:'虚拟游',href:'index.html#/vr?ljcode=720&columnId=40288a9d6e91c70a016e91cc6eb5000a&rootColumnId=40288a9d6e91c70a016e91c895ae0001',
                        child:[
                            {name:'720°全景游览',href:'index.html#/vr?ljcode=720&columnId=40288a9d6e91c70a016e91cc6eb5000a&rootColumnId=40288a9d6e91c70a016e91c895ae0001'},
                            {name:'漫游讲解',href:'index.html#/myjj?ljcode=myjj&columnId=2c9a4c9b6ea63d8c016ea6474f040002&rootColumnId=40288a9d6e91c70a016e91c895ae0001'},
                            {name:'场景切换',href:'index.html#/cjqh?ljcode=cjqh&rootColumnId=40288a9d6e91c70a016e91c895ae0001&columnId=cjqh'}]},
                    {name:'玩转廉江',href:'index.html#/list_wzlj?ljcode=ms&columnId=40288a9d6e91c70a016e91cd018f000b&rootColumnId=40288a9d6e91c70a016e91c90be20002',
                        child:[
                            {name:'美食',href:'index.html#/list_wzlj?ljcode=ms&columnId=40288a9d6e91c70a016e91cd018f000b&rootColumnId=40288a9d6e91c70a016e91c90be20002'},
                            {name:'住宿',href:'index.html#/list_wzlj_zs?ljcode=zs&columnId=40288a9d6e91c70a016e91cd2d41000c&rootColumnId=40288a9d6e91c70a016e91c90be20002'},
                            {name:'出行',href:'index.html#/list_wzlj_cx?ljcode=cx&columnId=40288a9d6e91c70a016e91cd57a1000d&rootColumnId=40288a9d6e91c70a016e91c90be20002'},
                            {name:'游玩',href:'index.html#/list_wzlj_yw?ljcode=yw&columnId=40288a9d6e91c70a016e91cd7efb000e&rootColumnId=40288a9d6e91c70a016e91c90be20002'},
                            {name:'购物',href:'index.html#/list_wzlj_gw?ljcode=gw&columnId=40288a9d6e91c70a016e91cdd286000f&rootColumnId=40288a9d6e91c70a016e91c90be20002'},
                            {name:'娱乐',href:'index.html#/list_wzlj_yl?ljcode=yl&columnId=40288a9d6e91c70a016e91ce074a0010&rootColumnId=40288a9d6e91c70a016e91c90be20002'},
                            {name:'特产',href:'index.html#/list_wzlj_tc?ljcode=tc&columnId=40288a9d6e91c70a016e91ce50ae0011&rootColumnId=40288a9d6e91c70a016e91c90be20002'},
                            {name:'红色景点',href:'index.html#/list_wzlj_jd?ljcode=jd&columnId=ff808081758d28430175912d1564005e&rootColumnId=40288a9d6e91c70a016e91c90be20002'}]},
                    {name:'廉江特色',href:'index.html#/tyfg?ljcode=tyfg&columnId=40288a9d6e91c70a016e91cecf5a0012&rootColumnId=40288a9d6e91c70a016e91c947000003',
                        child:[{name:'田园风光',href:'index.html#/tyfg?ljcode=tyfg&columnId=40288a9d6e91c70a016e91cecf5a0012&rootColumnId=40288a9d6e91c70a016e91c947000003'},
                            {name:'赏花观鸟',href:'index.html#/shgn?ljcode=shgn&columnId=40288a9d6e91c70a016e91cefea00013&rootColumnId=40288a9d6e91c70a016e91c947000003'},
                            {name:'美丽乡村',href:'index.html#/mlxc?ljcode=mlxc&columnId=40288a9d6e91c70a016e91cf30720014&rootColumnId=40288a9d6e91c70a016e91c947000003'}]},
                    {name:'互动交流',href:'index.html#/lygl?ljcode=lygl&columnId=40288a9d6e91c70a016e91cf71920015&rootColumnId=40288a9d6e91c70a016e91c982fd0004',
                        child:[{name:'旅游攻略',href:'index.html#/lygl?ljcode=lygl&columnId=40288a9d6e91c70a016e91cf71920015&rootColumnId=40288a9d6e91c70a016e91c982fd0004'},
                            {name:'游记分享',href:'index.html#/yjfx?ljcode=yjfx&columnId=40288a9d6e91c70a016e91cff15c0016&rootColumnId=40288a9d6e91c70a016e91c982fd0004'},
                            {name:'行程规划',href:'index.html#/xcgh?ljcode=xcgh&columnId=40288a9d6e91c70a016e91d01e460017&rootColumnId=40288a9d6e91c70a016e91c982fd0004'},
                            {name:'旅游线路',href:'index.html#/lyxl?ljcode=lyxl&columnId=40288a9d6e91c70a016e91d046210018&rootColumnId=40288a9d6e91c70a016e91c982fd0004'}]},
                    {name:'在线预订',href:'shop.html#/xlyd?columnId=8a9d2ba16f64df6e016f787cf46b000c&rootColumnId=2c9a4c9b6ea63d8c016ea6409e450001',
                        child:[
                            {name:'门票预订',href:'shop.html#/jqyd?columnId=8a9d2ba16f64df6e016f787d1a71000d&rootColumnId=2c9a4c9b6ea63d8c016ea6409e450001'},
                            ]},
                    {name:'旅游服务',href:'index.html#/lyzn?ljcode=lyzn&articleId=8a9d2ba16ec4607c016ec52657500000&columnId=40288a9d6e91c70a016e91d09edb0019&rootColumnId=40288a9d6e91c70a016e91ca6a640005',
                        child:[{name:'旅游指南',href:'index.html#/lyzn?ljcode=lyzn&articleId=8a9d2ba16ec4607c016ec52657500000&columnId=40288a9d6e91c70a016e91d09edb0019&rootColumnId=40288a9d6e91c70a016e91ca6a640005'},
                            {name:'在线咨询',href:'http://wpa.qq.com/msgrd?v=3&uin=1420561821&site=qq&menu=yes'},
                            {name:'投诉建议',href:'index.html#/tsjy?ljcode=tsjy&columnId=40288a9d6e91c70a016e91d0f659001b&rootColumnId=40288a9d6e91c70a016e91ca6a640005'},
                            {name:'旅游电话',href:'index.html#/lydh?ljcode=lydh&articleId=8a9d2ba16e01cf0d016e64426677010b&columnId=40288a9d6e91c70a016e91d12541001c&rootColumnId=40288a9d6e91c70a016e91ca6a640005'},
                            {name:'出游宝典',href:'index.html#/cybd?ljcode=cybd&articleId=8a9d2ba16e01cf0d016e64728b7a0115&columnId=40288a9d6e91c70a016e91d15ea2001d&rootColumnId=40288a9d6e91c70a016e91ca6a640005'},
                            {name:'常见问题',href:'index.html#/cjwt?ljcode=cjwt&articleId=8a9d2ba16ec4607c016ec59b69000005&columnId=40288a9d6e91c70a016e91d1972a001e&rootColumnId=40288a9d6e91c70a016e91ca6a640005'},
                            {name:'天气预报',href:'index.html#/tqyb?ljcode=tqyb&columnId=40288a9d6e91c70a016e91d1c39a001f&rootColumnId=40288a9d6e91c70a016e91ca6a640005'},
                        ]},
                ]

            }
        },
        created(){
            // this.getHrefs();
        },
        methods:{
            goTo(v){
                location.href = v;
            },
            getHrefs(){
                let url = `${api}/api/cms/column/list`;
                this.common.axios.get(url).then(v=>{
                        let data =v.data.data;
                        data.shift();
                        let arr = [];
                        for(let i = 0 ; i<data.length;i++){
                            if (data[i].level == "0") {
                                // console.log(data[i]);
                                let item = data[i];
                                item['child'] = [];
                                for (let j = 0; j < data.length; j++) {
                                    if (data[j].parent != null) {
                                        // console.log();
                                        if (data[j].parent.id == item.id) {
                                            item.child.push(data[j])
                                        }
                                    }
                                }
                                arr.push(item);
                            }
                        };
                        console.log(arr)
                        this.navlist = arr;

                    }
                )
            }
        }
    }
</script>
<style lang="less" scoped>
    .footer{
        width: 100%;
        background: rgb(51,51,51);
        .box{
            height: 434px;
            margin: 0 auto;

            .one{
                position: relative;
                height: 105px;
                color: white;
                text-align: left;
                line-height: 105px;
                font-size: 22px;
                font-weight:400;
                letter-spacing: 2px;
                display: flex;
                align-items: center;
                border-bottom: 1px solid #3E3E47;
            }
            .two{
                height: 329px;
                display: flex;
                flex-direction: row;
                .item{
                    flex: 1;
                    text-align: left;
                    .item_title{
                        color: white;
                        margin: 40px 0 40px 10px ;
                        font-size: 20px;
                    }
                    ul{
                        margin-left: 10px;
                        color: #7D808C;
                        li{
                            font-size: 14px;
                            margin-bottom: 15px;
                        }
                    }
                    .refer{
                        height: 40px;
                        width: 230px;
                        display: flex;
                        align-items: center;
                        background: rgb(72,72,72);
                        color: #999999;
                        margin-bottom: 10px;
                        img{
                            width: 24px;
                            margin-left: 20px;
                            margin-right: 20px;
                        }
                        span{

                        }
                    }
                };
                border-bottom: 1px solid #3E3E47;
            }

        }
        .three{
           // height: 40px;
            line-height: 20px;
            font-size:12px;
            font-weight:400;
            color:rgba(102,102,102,1);
            text-align: center;
            background: rgb(0,0,0,0.8);
            a{
                color:rgba(102,102,102,1);
                margin-right: 5px;
            }
        }


    }
</style>
